import RateModel from './rate.m';
import {INumber} from 'MWC';
import parser from '../parsers/main.m.p';

export default class extends RateModel {
    static parsers = {
        read: parser
    };

    rateB() {
        return new INumber(this.get('rateB').toFloat() / this.get('rateA').toFloat());
    }

    isProcessing() {
        return this.type === 'processing';
    }

    isNBU() {
        return this.type === 'nbu';
    }

    isBranches() {
        return this.type === 'branches';
    }
}
